import { toLower } from 'lodash'
import ApiTestInterface, { ApiTestRequestParams } from '../ApiTestInterface'
import Rest from '../Rest'

export default class V2Service extends Rest implements ApiTestInterface {
  /**
   * @type {String}
   */
  static resource = '/api/v2'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  search(params?: ApiTestRequestParams) {
    return this.get('test/search')
  }

  notFound(method) {
    return this[toLower(method)]('test/notfound')
  }
}
